import React from "react";
import { Link } from "react-router-dom";

import FooterLogoIcon from "../../../assets/icons/FooterLogoIcon";
import FacebookIcon from "../../../assets/icons/FacebookIcon";
import XIcon from "../../../assets/icons/XIcon";
import InstagramIcon from "../../../assets/icons/InstagramIcon";
import YouTubeIcon from "../../../assets/icons/YoutubeIcon";
import TelegramIcon from "../../../assets/icons/TelegramIcon";

/* ----------------------------------
   URL SLUG GENERATOR
---------------------------------- */
const toUrlFriendly = (text) =>
  text
    .toLowerCase()
    .replace(/ & /g, "-")
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");

/* ----------------------------------
   FOOTER DATA
---------------------------------- */

// Changed to objects to allow custom URLs that differ from the display name
const footerCategories = [
  { name: "Smart Li-Ion Batteries", slug: "smart-li-ion-batteries" },
  { name: "Lithium Phosphate", slug: "smart-lithium-phosphate-battery" }, // Custom URL updated here
  { name: "Scooty Batteries", slug: "scooty-batteries" },
  { name: "Smart Integrated Inverters", slug: "smart-integrated-inverters" },
  { name: "Bike Batteries", slug: "bike-batteries" },
  { name: "Car Batteries", slug: "car-batteries" },
  { name: "BMS Systems", slug: "bms-systems" },
];

const footerPolicies = [
  "Privacy Policy",
  "Refund & Cancellations",
  "Terms & Conditions",
  "About Us",
];

/* ----------------------------------
   FOOTER COMPONENT
---------------------------------- */

const Footer = () => {
  return (
    <footer className="footer section-reveal">
      <div className="footer-content">
        {/* LOGO + CONTACT */}
        <div className="footer-column about">
          <div className="logo-container">
            <FooterLogoIcon />
          </div>

          <p>Call us 10 AM - 6 PM</p>
          <p className="phone-number">+91 9123708861</p>

          {/* SOCIAL MEDIA */}
          <div className="social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>

            <a
              href="https://x.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X"
            >
              <XIcon />
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>

            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <YouTubeIcon />
            </a>

            <a
              href="https://telegram.org"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <TelegramIcon />
            </a>
          </div>
        </div>

        {/* CATEGORIES */}
        <div className="footer-column links">
          <h4>Categories</h4>

          <ul>
            {footerCategories.map((cat) => (
              <li key={cat.name}>
                {/* Now using the exact custom slug defined in the object */}
                <Link to={`/shop?category=${cat.slug}`}>{cat.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* POLICIES */}
        <div className="footer-column links">
          <h4>Our Policies</h4>

          <ul>
            {footerPolicies.map((policy) => (
              <li key={policy}>
                {/* Policies still use the auto-generator for convenience */}
                <Link to={`/${toUrlFriendly(policy)}`}>{policy}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-column contact">
          <h4>Contact Us</h4>

          <p>
            Near Youniform World, Gobardanga station road, Ramnagar
            <br />
            North 24 Parganas – 743273
            <br />
            West Bengal, India
          </p>

          <a href="mailto:support@zynvert.com">info@zynventics.com</a>
        </div>
      </div>

      {/* BOTTOM SECTION */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Zynventics Technologies Pvt. Ltd. All
          rights reserved.
        </p>

        <div className="payment-info">
          <span>We Use Safe Payment For</span>

          <img
            src="https://placehold.co/150x25/ffffff/333?text=Payment+Methods"
            alt="Secure Payment Methods"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
